import { render, staticRenderFns } from "./fps-bar.vue?vue&type=template&id=307547ac&scoped=true&"
import script from "./fps-bar.vue?vue&type=script&lang=js&"
export * from "./fps-bar.vue?vue&type=script&lang=js&"
import style0 from "./fps-bar.vue?vue&type=style&index=0&id=307547ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307547ac",
  null
  
)

export default component.exports